var _effectorFileName = "/src/features/quiz/components/quiz-result-content.tsx";
import React from 'react';
import { cn } from '@/shared/lib/cn';
interface QuizResultContentProps {
  className?: string;
  children?: React.ReactNode;
}
export const QuizResultContent = React.forwardRef<HTMLDivElement, QuizResultContentProps>(({
  className,
  children,
  ...props
}, ref) => {
  return <div ref={ref} className={cn('flex flex-col gap-3 sm:flex-row', className)} {...props}>
        {children}
      </div>;
});
QuizResultContent.displayName = 'QuizResultContent';